import * as yup from "yup";

export const yupSchema = yup.object().shape({
  razaoSocial: yup.string().required("Esse campo é obrigatório"),
  nomeFantasia: yup.string(),
  nomeMotorista: yup.string(),
  veiculo: yup.string(),
  cpfMotorista: yup.string(),
  telefone: yup.string(),
  celular: yup.string(),
  inscricaoEstadual: yup.string(),
  inscricaoMunicipal: yup.string(),
  cep: yup.string(),
  logradouro: yup.string(),
  numero: yup.string(),
  complemento: yup.string(),
  bairro: yup.string(),
  cidade: yup.string(),
  uf: yup.string(),
  email: yup.string().email("Email inválido"),
  ativo: yup.boolean(),
  ativo_obs: yup.string(),
});

export const initialValues = {
  razaoSocial: "",
  nomeFantasia: "",
  nomeMotorista: "",
  veiculo: "",
  cpfMotorista: "",
  telefone: "",
  celular: "",
  inscricaoEstadual: "",
  inscricaoMunicipal: "",
  cep: "",
  logradouro: "",
  numero: "",
  complemento: "",
  bairro: "",
  cidade: "",
  uf: "",
  email: "",
  ativo: true,
  ativo_obs: "",
};
